(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-content-cards"] && !Shopify.designMode) return;
  try {
    
  // If autoplay enabled, play the video only if the video is visible.
  document.querySelectorAll('.js-video').forEach((video) => {
    if (video.attributes.autoplay !== undefined ) {
      let isPaused = false; /* Flag for auto-paused video */
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio != 1  && !video.paused) {
            video.pause();
            isPaused = true;
          }
          else if (isPaused) {
            video.play();
            isPaused = false
          }
        });
      }, {threshold: 1});
      observer.observe(video);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-content"] && !Shopify.designMode) return;
  try {
    
  // If autoplay enabled, play the video only if the video is visible.
  (() => {
    const initFeaturedContentVideoControls = (featuredContentSection) => {
      if (!featuredContentSection || featuredContentSection.__featuredContentVideoControlsBound) {
        return;
      }

      featuredContentSection.__featuredContentVideoControlsBound = true;

      const syncVideoToggleState = (video) => {
        if (!(video instanceof HTMLVideoElement) || !featuredContentSection.contains(video)) {
          return;
        }

        const mediaContainer = video.closest('.featured-content__media--video-control');
        const videoToggle = mediaContainer ? mediaContainer.querySelector('[data-video-toggle]') : null;

        if (!videoToggle) {
          return;
        }

        const isPlaying = !video.paused && !video.ended;

        videoToggle.classList.toggle('is-playing', isPlaying);
        videoToggle.classList.toggle('is-paused', !isPlaying);
        videoToggle.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
        videoToggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      };

      featuredContentSection.querySelectorAll('[data-video-toggle]').forEach((videoToggle) => {
        const relatedVideo = videoToggle.parentElement ? videoToggle.parentElement.querySelector('video') : null;
        if (relatedVideo instanceof HTMLVideoElement) {
          if (!relatedVideo.id) {
            relatedVideo.id = `featured-content-video-${Math.random().toString(36).slice(2, 10)}`;
          }
          videoToggle.setAttribute('aria-controls', relatedVideo.id);
        }

        videoToggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const video = event.currentTarget.parentElement.querySelector('video');

          if (!(video instanceof HTMLVideoElement)) {
            return;
          }

          if (video.paused || video.ended) {
            syncVideoToggleState(video);
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {
                syncVideoToggleState(video);
              });
            }
          } else {
            video.pause();
          }
        });
      });

      featuredContentSection.querySelectorAll('.js-video').forEach((video) => {
        video.addEventListener('play', () => syncVideoToggleState(video));
        video.addEventListener('pause', () => syncVideoToggleState(video));
        video.addEventListener('ended', () => syncVideoToggleState(video));
        syncVideoToggleState(video);
        if (video.attributes.autoplay !== undefined) {
          let isPaused = false; /* Flag for auto-paused video */
          const observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio != 1 && !video.paused) {
                  video.pause();
                  isPaused = true;
                } else if (isPaused) {
                  video.play();
                  isPaused = false;
                }
                syncVideoToggleState(video);
              });
            },
            { threshold: 1 }
          );
          observer.observe(video);
        }
      });
    };

    document.querySelectorAll('[data-featured-content-video-controls]').forEach((sectionElement) => {
      initFeaturedContentVideoControls(sectionElement);
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      event.target.querySelectorAll('[data-featured-content-video-controls]').forEach((sectionElement) => {
        initFeaturedContentVideoControls(sectionElement);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
